import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { fetchOrganization } from '@common/resources/Organization/actions';
import { fetchVenue } from '@resources/Venue/actions';
import { fetchSubmodulesByModuleCode } from '@resources/Submodule/actions';
import { Box, Container, Title, View } from '@common/components';
import { Menu, Typography } from 'antd';

const VenueInfo = ({
	venue,
	submodules,
	organization,
	fetchVenue,
	fetchSubmodulesByModuleCode,
	history,
	match,
}) => {
	const { venueId, submoduleCode } = match?.params || {};
	const [current, setCurrent] = useState(submoduleCode || 'details');

	useEffect(() => {
		const fetchData = async () => {
			await fetchVenue(venueId);
			await fetchSubmodulesByModuleCode('venue');
		};

		fetchData();
	}, [fetchVenue]);

	const handleClick = (e) => {
		if (e.key === 'details') {
			history.push(
				organization?.alias
					? `/${organization?.alias}/venues/${venueId}/details`
					: `/venues/${venueId}/details`
			);
		} else {
			history.push(
				organization?.alias
					? `/${organization?.alias}/venues/${venueId}/details/${e.key}`
					: `/venues/${venueId}/details/${e.key}`
			);
		}

		setCurrent(e.key);
	};

	return (
		<Container>
			<View>
				<Box py={50}>
					<Title fontSize={100} lineHeight={1} mb={10}>
						{venue.title}
					</Title>
					<Typography.Title level={2}>Venue</Typography.Title>
				</Box>
				<Menu
					onClick={handleClick}
					mode="horizontal"
					selectedKeys={[current]}>
					<Menu.Item key="details">Details</Menu.Item>
					{submodules &&
						submodules.map((submodule) => (
							<Menu.Item key={submodule.url}>
								{submodule.title}
							</Menu.Item>
						))}
				</Menu>
			</View>
		</Container>
	);
};

const mapStateToProps = ({ venue, submodules, organization }) => {
	return {
		venue,
		submodules,
		organization,
	};
};

export default connect(mapStateToProps, {
	fetchOrganization,
	fetchVenue,
	fetchSubmodulesByModuleCode,
})(VenueInfo);
